import { render, staticRenderFns } from "./ECodigoDeConfirmacao.vue?vue&type=template&id=066d7a5b"
import script from "./ECodigoDeConfirmacao.vue?vue&type=script&lang=js"
export * from "./ECodigoDeConfirmacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports